<template>
  <div class="container-fluid py-4 px-4">
    <div class="row no-gutters text-left">
      <div class="col-12 col-md-3">
        <h4 class="font-weight-bold mb-0">SI Accounts</h4>
      </div>

      <div class="col-12 col-sm-6 col-md-4">
        <div class="input-group input-group-sm mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">
              &#128269;
            </span>
          </div>
          <input type="text"
                 class="form-control"
                 placeholder="Search"
                 aria-label="Search"
                 aria-describedby="basic-addon1">
        </div>
      </div>
    </div>

    <div class="row no-gutters mt-2">
      <div class="col-md-12">
        <base-table :max-height="720" >
          <template slot="table-header">
            <tr>
              <th  scope="col" class="p-1" width="15%">LAST NAME</th>
              <th scope="col" class="p-1" width="15%">FIRST NAME</th>
              <th scope="col" class="p-1" width="15%">MIDDLE NAME</th>
              <th scope="col" class="p-1" width="10%">EMAIL</th>
              <th scope="col" class="p-1" width="10%">CONTACT</th>
              <th scope="col" class="p-1" width="10%">USERNAME</th>
              <th scope="col" class="p-1" width="10%">ACTION</th>
            </tr>
          </template>

          <template slot="table-body">
            <tr>
              <td>DOE</td>
              <td class="align-middle">JOHN</td>
              <td>MI</td>
              <td>johndoe@gmail.com</td>
              <td>543543 543534 </td>
              <td>3232 3232</td>
              <td class="align-middle">
                <button class="btn btn-sm btn-danger">
                  <span class="ml-1">DELETE</span>
                </button>
              </td>
            </tr>

          </template>
        </base-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'siUserTable',

  /** mixins **/
  mixins: [],

  /** props **/
  props: {},

  /** data **/
  data() {
    return {};
  },

  /** methods**/
  methods: {},

  /**  computed  **/
  computed: {},

  /** mounted **/
  mounted() {
  },

  /** created **/
  created() {
  },

  watch: {},

  /** destroyed **/
  destroyed() {
  },
};
</script>

<style scoped>

</style>
